const ACCOUNT_ROOT_PATH = '/account';
const REQUEST_ROOT_PATH = '/orderService';
const TRACKING_ROOT_PATH = '/tracking';

export const ROUTES = Object.freeze({
  ROOT: '/',

  // Auth Routes
  LOGIN: '/login',
  GIFT_LOGIN: '/gift-login',
  SIGN_IN: '/signin',
  LOGOUT: '/logout',
  ERROR: '/error',
  NOT_FOUND: '/404',
  DISABLED: '/disabled',
  COVID: '/COVID-instructions', // DEPRECATED

  // Public Routes
  QR_SHIPPING_LABEL: '/qr-shipping-label',
  DROPOFF_LOCATIONS: '/dropoff-locations/:os_id',

  // Protected Routes
  // ACCOUNT: '/account',
  ORDER_DETAILS: '/orders/:id',
  TRACKING: Object.freeze({
    ROOT: TRACKING_ROOT_PATH,
    DETAILS: `${TRACKING_ROOT_PATH}/:shipmentID`,
  }),
  ORDER_TRACK: '/orders/:orderID/track/:fulfillmentID',
  ORDER_SERVICE_TRACK: '/orders/:orderID/request/:serviceID',
  RETEX_TRACK: '/orders/:orderID/retex/:serviceID', // TODO SARTHAK: Change to retexID
  ACCOUNT: Object.freeze({
    ROOT: ACCOUNT_ROOT_PATH,
    ORDERS: `${ACCOUNT_ROOT_PATH}/orders`,
    RETURNS: `${ACCOUNT_ROOT_PATH}/returns`,
    RETURNS_DETAILS: `${ACCOUNT_ROOT_PATH}/returns/:returnId`,
  }),
  REQUEST: Object.freeze({
    ROOT: REQUEST_ROOT_PATH,
    CREATE: Object.freeze({
      INIT: `${REQUEST_ROOT_PATH}/:orderId`,
      INIT_CACHED: `${REQUEST_ROOT_PATH}/:orderId/:orderServiceId`,
      DETAILS: `${REQUEST_ROOT_PATH}/details/:serviceId`,
      CONFIRMATION: `${REQUEST_ROOT_PATH}/complete/:serviceId`,
    }),
  }),
});
